export default "__VITE_ASSET__9VPLdXMM__"